<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0090_deposit_certificate_output</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-search title="預り証出力"></title-and-search>
          <div class="row" :style="'margin-top:3px;margin-bottom:30px;'">
            <div class="col-xs-4">
              <search-company @search="onSearchEvent"/>
            </div>
          </div>

          <search-control
          style="padding-bottom: 10px;"
          :field_names="allFields" @change="searchControlChangedDatasource"></search-control>
          <ag-grid-vue style="width: 100%; height: 325px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
          <br>
          <div style="float: left;;margin-top:5px">
            件数
            </div>
            <input type="text" data-cy="totalNumberOfRows" style="width: 5%;text-align: right;float: left;margin-left:5px" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
          <div style="margin-top:5px;">
            <button
            :disabled="formExportFileDisabled || checkUserPermission(true,permissionMode.EXPORT) == false"
            class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #b83261;background: #337ab7;" @click="initExportFile" >出力</button>
            <br>
            <br>
            <!-- <device-embedded-information-bach-edit-modal tag="showDeviceEmbeddedInformationBachEditModal" /> -->
            <file-download-modal tag="runDepositCertificateOutputDownloadModal" @close="onCloseExportFile"/>
          </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import uuid from "uuid";
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_certificate_software';
import { utils } from '@/libs/utils';
import searchCompany from "@/components/search-company";



import _debug from 'debug';
var mdebug = _debug('esma:certificate_software');
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import fileDownloadModal from '@/components/modals/file-download-modal';
import { bus } from '@/libs/bus';

export default {
  mixins: [mixinPageCommon,mixinDatasource],
  components: {
    'ag-grid-vue': AgGridVue,
    'file-download-modal':fileDownloadModal,
    "search-company":searchCompany
  },
  data() {
    return {
      api_name:"certificate_software_deposit",
      page_acl: acl.master,
      detail_page:"page_0040_certificate_software_detail_number_deposit",
      execute_filter_on_back:true,
      link_to_open:"#",
      search_data:{},
      local_list_of_fields:[]
    };
  },
  computed: {
    localListOfFields:{
      get(){
        return this.local_list_of_fields;
      },
      set(v){
        this.local_list_of_fields = v;
      }
    },

    linkToOpen:{
      get(){
        return this.link_to_open;
      },
      set(v){
        this.link_to_open = v;
      }
    },
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        utils.extend(fields.maker, {}),
        utils.extend(fields.license_name, {}),
        utils.extend(fields.license_certificate_type, {}),
        utils.extend(fields.license, {}),
        utils.extend(fields.certificate_software_number, {}),
      ];
    },
    formFields() {
      return {
        col1: this.localListOfFields
      }
    }
  },
  methods: {
    onSearchEvent(arr){
      arr.forEach(a=>{
        this.search_data[a.id] = a.val;
      })
      this.sub_search = this.search_data;
      this.gridOptions.api.purgeInfiniteCache();
      this.countRows("inventory_certificate_list");
    },
    onSearchValue(id,val){
      console.log('TEST DEBUG 210430 (143 at page_0090_deposit_certificate_output.vue)[23:50]: ', {id,val });
      this.search_data[id] = val;
      this.sub_search = this.search_data;
      this.gridOptions.api.purgeInfiniteCache();
      this.countRows("inventory_certificate_list");
      // bus.$emit("inventory_sub_search",{search_data:this.search_data})
    },

    initExportFile(){
      //FILE_EXPORT_PART2 : Step 2
      bus.$emit("runDepositCertificateOutputDownloadModal",{
        message: "ファイルを出力しています。",
        on_complete_message:"出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        api_request_options: {sub_search: "sub_search", filter_mode: "使用中"},
        sub_search:this.search_data,
        url:"/certificate_software_deposit/export_data/"
      });
    },
    onCloseExportFile(){},
    onDetailsClick(ev, data) {
      window.sessionStorage.setItem('certificate_back_to_list', "/deposit_certificate_output")
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: {  seq_id:data.seq_id} });
    },
    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:true,show_checkbox:false})
    },

  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
    setTimeout(() => {
      // this.startCompanySelection();  
    }, 500);
    
  },
  beforeDestroy() {
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    this.api_request_options = {sub_search:"sub_search",filter_mode:"使用中"};
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.initDatasource();
  }
};

</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0090_deposit_certificate_output.vue?72770264